<h4 mat-dialog-title>
  <span *ngIf="!data; else editHeader"> Creazione nuovo studio </span>
  <ng-template #editHeader> Modifica studio {{ data.nome }} </ng-template>
</h4>
<form *ngIf="form" [formGroup]="form" class="mt-4" (keydown.enter)="edit()">
  <mat-form-field>
    <mat-label>Nome</mat-label>
    <input matInput formControlName="nome" />
    <mat-icon matSuffix>nome</mat-icon>
  </mat-form-field>

  <mat-form-field>
    <mat-label> Via / piazza </mat-label>
    <input matInput formControlName="via" />
  </mat-form-field>

  <mat-form-field>
    <mat-label> N. civico </mat-label>
    <input matInput formControlName="civico" />
  </mat-form-field>

  <mat-form-field>
    <mat-label> Comune </mat-label>
    <comune-picker formControlName="comune"></comune-picker>
  </mat-form-field>

  <mat-form-field>
    <mat-label> Telefono </mat-label>
    <input matInput formControlName="tel" />
  </mat-form-field>
  <mat-form-field>
    <mat-label> Cellulare </mat-label>
    <input matInput formControlName="cell" />
  </mat-form-field>
  <mat-form-field>
    <mat-label> Fax </mat-label>
    <input matInput formControlName="fax" />
  </mat-form-field>
  <mat-form-field>
    <mat-label> Email </mat-label>
    <input matInput formControlName="email" />
  </mat-form-field>
  <mat-form-field>
    <mat-label> Firmatario </mat-label>
    <user-picker
      [defaultSearch]="{ ruoli: [17], studio: form?.value?.studio }"
      formControlName="firmatario"
    ></user-picker>
  </mat-form-field>

  <div class="mt-3 mb-3">
    <mat-checkbox formControlName="detrazione_accertamento_su_incaricato">
      Detrai automaticamente compenso accertatore da emolumento collaboratore
    </mat-checkbox>
  </div>
</form>
<button mat-raised-button (click)="edit()" color="primary">Salva</button>
